import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import * as reqAssignPatient from '../../../redux/board/reqAssignPatient';
import * as addPatient from '../../../redux/profiles/addPatientByProvider';
import { selectCountryPhoneSettings } from '../../../redux/data/selectors';
import {
  selectAddedPatientsList,
  addPatientErrorSelector,
  addPatientSendingSelector,
  selectSavedPatientContacts,
  selectCurrentCountryCode,
} from '../../../redux/profiles/selectors';

import {
  selectReqAssignPatientPending,
  selectReqAssignPatientSucceed,
} from '../../../redux/board/selectors/relatedUsers';
import styles from '../../DependentForm/styles.styl';

const mapStateToProps = state => ({
  pendingAssignPatient: selectReqAssignPatientPending(state),
  succeedAssignPatient: selectReqAssignPatientSucceed(state),
  patientContacts: selectSavedPatientContacts(state),
  existingUsers: selectAddedPatientsList(state),
  pending: addPatientSendingSelector(state),
  errors: addPatientErrorSelector(state),
  phoneNumberCountryIsoCode: selectCurrentCountryCode(state),
  countryPhoneSettings: selectCountryPhoneSettings(state),
});

const mapDispatchToProps = {
  checkUserContact: addPatient.actions.send,
  assignPatient: reqAssignPatient.actions.send,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientRegistrationContact/enhance.js